<page-header title="Activity" [subtitle]="subtitle"></page-header>

<div class="row">
  <div class="col-lg-12">
    <div
      style="
        background-color: var(--app-container);
        border-radius: 10px;
        padding: 10px;
      "
      *ngIf="!loading"
    >
      <mat-tab-group
        mat-align-tabs="start"
        mat-stretch-tabs="false"
        disableRipple="true"
        [animationDuration]="0"
        [(selectedIndex)]="selectedIndex"
        (selectedTabChange)="tabChanged($event.index)"
      >
        <mat-tab label="Stamps" *ngIf="hasStampCards !== false">
          <ngx-datatable
            #stampsTable
            class="material"
            [headerHeight]="45"
            [rows]="recentStamps"
            [scrollbarV]="false"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [messages]="{ emptyMessage: 'No stamps to display' }"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="stampLength"
            [offset]="stampPageIndex"
            (page)="stampPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="stampPageSize"
          >
            <ngx-datatable-column name="Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/card', row?.card?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.card?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Customer" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Stamp #" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.stampNumber }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <img
                  *ngIf="constants.isShopify(row)"
                  src="../../../assets/shopify-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquare(row)"
                  src="../../../assets/square-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isZapier(row)"
                  src="../../../assets/zapier-logo-small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isMake(row)"
                  src="../../../assets/make.jpeg"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquarespace(row)"
                  src="../../../assets/squarespace_logo_small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="showLocation"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="stampLength > 0">
                  <span>{{ stampsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="stampPageIndex + 1"
                  [size]="pageSize"
                  [count]="stampLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="stampsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>

        <mat-tab label="Points" *ngIf="hasPointsCards !== false">
          <ngx-datatable
            #pointsTable
            class="material"
            [headerHeight]="45"
            [rows]="recentPoints"
            [scrollbarV]="false"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [messages]="{ emptyMessage: 'No points to display' }"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="pointsLength"
            [offset]="pointsPageIndex"
            (page)="pointsPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="pointsPageSize"
          >
            <ngx-datatable-column name="Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/card', row?.card?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.card?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Customer" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Points" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.points | number: "1.0-0" }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <img
                  *ngIf="constants.isShopify(row)"
                  src="../../../assets/shopify-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquare(row)"
                  src="../../../assets/square-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquarespace(row)"
                  src="../../../assets/squarespace_logo_small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isZapier(row)"
                  src="../../../assets/zapier-logo-small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isMake(row)"
                  src="../../../assets/make.jpeg"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="showLocation"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="pointsLength > 0">
                  <span>{{ pointsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="pointsPageIndex + 1"
                  [size]="pageSize"
                  [count]="pointsLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="pointsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>

        <mat-tab label="Redemptions">
          <ngx-datatable
            #redemptionsTable
            class="material"
            [headerHeight]="45"
            [rows]="redemptions"
            [scrollbarV]="false"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [messages]="{ emptyMessage: 'No redemptions to display' }"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="redemptionLength"
            [offset]="redemptionPageIndex"
            (page)="redemptionPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="redemptionPageSize"
          >
            <ngx-datatable-column name="Redemption Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/reward', row?.reward?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.reward?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Customer" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="showLocation"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="redemptionLength > 0">
                  <span>{{ redemptionsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="redemptionPageIndex + 1"
                  [size]="pageSize"
                  [count]="redemptionLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="redemptionsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>

        <mat-tab label="Cards">
          <ngx-datatable
            #cardsTable
            class="material"
            [headerHeight]="45"
            [rows]="cards"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No loyalty cards to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="cardsLength"
            [offset]="cardsPageIndex"
            (page)="cardPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="cardsPageSize"
          >
            <ngx-datatable-column name="Date Taken" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="!(row?.card[0] ?? row?.card)?.title">
                  {{ (row?.card[0] ?? row?.card)?.title ?? "" }}
                </div>

                <a
                  *ngIf="(row?.card[0] ?? row?.card)?.title"
                  [routerLink]="['/card', (row?.card[0] ?? row?.card)?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ (row?.card[0] ?? row?.card)?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Customer" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Type"
              [resizeable]="true"
              *ngIf="showCardTypeColumn"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ cardType(row) }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Progress" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div style="display: flex">
                  <mat-progress-spinner
                    style="margin-right: 5px"
                    class="progress"
                    [color]="color"
                    [mode]="mode"
                    [value]="valueObtainedPercent(row)"
                    [diameter]="20"
                    *ngIf="
                      (row?.card[0] ?? row?.card)?.points?.maxPoints > 0 ||
                      (row?.card[0] ?? row?.card)?.cardType === 'stamp'
                    "
                  >
                  </mat-progress-spinner>
                  <span>
                    {{
                      valueObtained(row).includes("/")
                        ? valueObtained(row)
                        : (valueObtained(row) | number: "1.0-0")
                    }}
                  </span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="cardsLength > 0">
                  <span>{{ cardsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="cardsPageIndex + 1"
                  [size]="pageSize"
                  [count]="cardsLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="cardsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>

        <mat-tab label="Rewards">
          <ngx-datatable
            #rewardsTable
            class="material"
            [headerHeight]="45"
            [rows]="rewards"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No rewards to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="rewardsLength"
            [offset]="rewardsPageIndex"
            (page)="rewardPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="rewardsPageSize"
          >
            <ngx-datatable-column name="Date Received" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template ngx-datatable-header-template>
                <div style="display: flex; flex-direction: column">
                  <div>Reward</div>
                  <div style="font-size: 12px; opacity: 0.7">Hidden Text</div>
                </div>
              </ng-template>

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="!(row?.reward[0] ?? row?.reward)?.title">
                  {{ (row?.reward[0] ?? row?.reward)?.title ?? "" }}
                </div>

                <a
                  *ngIf="(row?.reward[0] ?? row?.reward)?.title"
                  [routerLink]="[
                    '/reward',
                    (row?.reward[0] ?? row?.reward)?.nanoid,
                  ]"
                  (click)="$event.stopPropagation()"
                >
                  {{ (row?.reward[0] ?? row?.reward)?.title }}
                </a>

                <div
                  *ngIf="row?.rewardObj?.hiddenText"
                  class="reward-hidden-text"
                  [title]="row?.rewardObj?.hiddenText"
                >
                  {{ row?.rewardObj?.hiddenText }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Customer" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="canViewCustomers; else noLink">
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.user?.name ?? row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ row?.user?.name ?? row?.customer?.name }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div style="display: flex; align-items: center; gap: 4px">
                  {{ constants.userRewardSource(row) }}

                  <info-icon
                    *ngIf="row?.gifted && row?.giftedByUser"
                    [text]="constants.getGifterTooltip(row)"
                  ></info-icon>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Expiry" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row?.expiry
                    ? (row?.expiry | date: constants.longDate)
                    : "Never"
                }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Status" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div
                  id="status-chip"
                  [ngClass]="constants.statusChipClass(row)"
                >
                  {{ constants.statusChipLabel(row) }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="rewardsLength > 0">
                  <span>{{ rewardsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="rewardsPageIndex + 1"
                  [size]="pageSize"
                  [count]="rewardsLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="rewardsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>

        <mat-tab label="Vouchers" *ngIf="hasVouchers !== false">
          <div
            style="
              padding: 10px 0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <mat-slide-toggle
              [(ngModel)]="showOnlyNonRedeemed"
              (change)="onNonRedeemedToggleChange()"
              color="primary"
            >
              {{
                showOnlyNonRedeemed ? "Non-redeemed vouchers" : "All vouchers"
              }}
            </mat-slide-toggle>
          </div>
          <ngx-datatable
            #vouchersTable
            class="material"
            [headerHeight]="45"
            [rows]="vouchers"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No vouchers to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="vouchersLength"
            [offset]="vouchersPageIndex"
            (page)="voucherPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="vouchersPageSize"
            (activate)="rowTappedNGX($event)"
          >
            <ngx-datatable-column
              name="Date"
              [maxWidth]="120"
              [resizeable]="false"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.shortDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Voucher"
              [resizeable]="false"
              [minWidth]="200"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a>
                  {{ (row?.voucher[0] ?? row?.voucher)?.displayAs }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Purchaser" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container
                  *ngIf="canViewCustomers && row?.customer?.nanoid; else noLink"
                >
                  <a
                    [routerLink]="['/customer', row?.customer?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ row?.customer?.name }}
                  </a>
                </ng-container>
                <ng-template #noLink>
                  {{ getPurchaserName(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <!-- Recipient -->
            <ngx-datatable-column name="Recipient" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.recipient?.name ?? "Self-purchase" }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Status" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div
                  id="status-chip"
                  [ngClass]="constants.statusChipClass(row)"
                >
                  {{ constants.statusChipLabel(row) }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Redeemable Value" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.value | currency: "GBP" }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Remaining" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.remainingValue ?? row?.value | currency: "GBP" }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Cost" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.cost | currency: "GBP" }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Expiry" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row?.expiry
                    ? (row?.expiry | date: constants.shortDate)
                    : "Never"
                }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="vouchersLength > 0">
                  <span>{{ vouchersRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="vouchersPageIndex + 1"
                  [size]="pageSize"
                  [count]="vouchersLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="vouchersTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<loader [loading]="loading"></loader>
